import React, {useState} from 'react'
import NewUserPopup from './NewUserPopup'
import {Button} from "antd"

function NewUser(props) {
    const [isOpen, setIsOpen] = useState(false)

    const _showModal = () => {
        setIsOpen(true)
    }

    const _closeModal = () => {
        setIsOpen(false)
    }

    return (
        <div className="NewUser">
            <Button type="primary" onClick={_showModal}>
                Add user
            </Button>
            {isOpen && <NewUserPopup {...props} isOpen={isOpen} onClose={_closeModal}/>}
        </div>
    )
}

export default NewUser